import { render, staticRenderFns } from "./addressCreate.vue?vue&type=template&id=2477fe1d&scoped=true&"
import script from "./addressCreate.vue?vue&type=script&lang=js&"
export * from "./addressCreate.vue?vue&type=script&lang=js&"
import style0 from "./addressCreate.vue?vue&type=style&index=0&id=2477fe1d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2477fe1d",
  null
  
)

export default component.exports